// extracted by mini-css-extract-plugin
module.exports = {"scrollToTopBtn":"ScrollToTopButton_scrollToTopBtn__4c3n2","isActive":"ScrollToTopButton_isActive__y8Czk"};